<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details"
              | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxFlex="100">
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field id="matFrmFieldProvider" style="width: 100%;">
                    <mat-label
                      >{{ "module-assignment.salesforce_settings.version" | translate }}</mat-label
                    >
                    <mat-select id="salesforceVersion" formControlName="salesforceVersion">
                      <mat-option value="">Please select</mat-option>
                      <mat-option value="1">Version 1.0</mat-option>
                      <!-- <mat-option value="2">Version 2.0</mat-option> -->
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="mat-block">
                    <input
                      formControlName="ebasketMixSaleSalesforceClientId"
                      id="ebasketMixSaleSalesforceClientId"
                      matInput
                      [placeholder]="
                    'module-assignment.salesforce_settings.clientId' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title
                >{{ "module-assignment.salesforce_settings.api_details" | translate
                }}</mat-card-title
              >
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isEBasketMixSaleSalesforceAddDisabled"
                mat-flat-button
                color="primary"
                (click)="openEbasketMixSaleSalesforceSelectApiPopup();"
              >
                {{ 'module-assignment.salesforce_settings.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketMixSaleSalesforceApiDetails')['controls']; let i = index"
            formArrayName="ebasketMixSaleSalesforceApiDetails"
          >
            <div [formGroupName]="i">
              <div fxFlex="80">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ apiDetails.value.selectedApi}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            id="saleforceUrl"
                            [required]="isRequired('url')"
                            formControlName="url"
                            matInput
                            [placeholder]="
                    'module-assignment.salesforce_settings.url' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxFlex="20" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteEbasketSalesforceApiDetailContainer(i);"
                >
                  {{ 'module-assignment.salesforce_settings.delete' | translate}}
                </button>
              </div>
            </div>
          </mat-card-content>
          <div
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketMixSaleSalesforceApiDetails')['controls']; let i = index"
          >
            <mat-error *ngIf="!apiDetails.value.url && action !== 'view'">
              {{"module-assignment.salesforce_settings.api_details_required" | translate }}
            </mat-error>
          </div>
        </mat-card>
      </div>
      <!-- <mat-error *ngIf="!parentForm.valid || !isEBasketMixSaleSalesforceAddDisabled">
        {{ "module-assignment.salesforce_settings.auth_details_required" | translate }}
      </mat-error> -->
    </div>
  </div>
</div>
